import React, { useState, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import { ModalContext } from 'App';
import { IconEyeOff, IconEyeOn } from 'modules/common/components/Icons';
import PropTypes from 'prop-types';
import * as actions from '../action';
import * as c from '../constant';

const form = {
  password: '',
  password_confirmation: '',
}

function PasswordModal({
  disable2fa,
  history,
  isLoading,
  getProfile,
}) {

  const setModal = useContext(ModalContext);
  const [formData, setFormData] = useState(form);
  const [hidden, setHidden] = useState({ hidden: false });

  const handleOnChange = (e) => {
    e.preventDefault();
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();
    disable2fa(formData, (profile) => {
      setModal({ isOpen: false });
      getProfile(_.get(profile, 'data.id'));
      history.push('/profile');
    });
  };

  return (
    <Modal.Body>
      <div className="content">
        <div className="login-box">
          <form onSubmit={handleOnSubmit} className="login-form">
            <div className="form-group">
              <div className="inner-addon right-addon right-addon-button">
                <input
                  type={hidden ? 'password' : 'text'}
                  placeholder="Password"
                  onChange={handleOnChange}
                  value={_.get(formData, 'password') || ''}
                  name="password"
                  id="loginPassword"
                  className="form-control form-control-lg form-control-icon"
                />
                <button
                  type="button"
                  tabIndex={-1}
                  className="btn btn-right"
                  onClick={() => setHidden(!hidden)}
                >
                  {hidden ? <IconEyeOn /> : <IconEyeOff />}
                </button>
              </div>
            </div>
            <div className="form-group">
              <div className="inner-addon right-addon right-addon-button">
                <input
                  type={hidden ? 'password' : 'text'}
                  placeholder="Confirm Password"
                  onChange={handleOnChange}
                  value={_.get(formData, 'password_confirmation') || ''}
                  name="password_confirmation"
                  id="password_confirmation"
                  className="form-control form-control-lg form-control-icon"
                />
                <button
                  type="button"
                  tabIndex={-1}
                  className="btn btn-right"
                  onClick={() => setHidden(!hidden)}
                >
                  {hidden ? <IconEyeOn /> : <IconEyeOff />}
                </button>
              </div>
            </div>
            <button
              type="submit"
              disabled={isLoading}
              className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-block btn-signin"
              style={{
                cursor: isLoading ? 'not-allowed' : 'pointer',
              }}
            >
              {isLoading && <i className="fas fa-spin fa-spinner" />}{' '}
              Submit
            </button>
          </form>
        </div>
      </div>
    </Modal.Body>
  );
}

PasswordModal.propTypes = {
  history: PropTypes.instanceOf(Object).isRequired,
  disable2fa: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  getProfile: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  isLoading: api.loading.indexOf(c.DISABLE_2FA) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(
    mapStateToProps,
    {
      ...actions,
    },
  ),
]);

export default enhance(PasswordModal);